import React from 'react';
import PropTypes from 'prop-types';
import './NotFound.css';

const NotFound = ({ heading, button }) => {
    return (

        <div className="not-found-container text-center ">
            <h2 className="not-found-subtitle">{heading}</h2>
            <p className="not-found-text">
                The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
            </p>
            {button}
        </div>
    );
};
NotFound.propTypes = {
    heading: PropTypes.string,
    button: PropTypes.node
};

export default NotFound;